/**
 * Devis depuis le PANIER (drawer) + bascule du bouton de checkout.
 * Déporté du template configurateur.liquid (proche de la limite Shopify 256 Ko).
 *
 * Dépendances exposées par le template sur window :
 *   window.getCartItems()   -> tableau des articles du panier (cartItems)
 *   window.openQuoteModal(data)
 *   window.closeCartDrawer()
 *   window.goToRecap()
 *   window.countCartFamilies() reste ici (autonome).
 *
 * Règles de bascule « Continuer » -> « Faire une demande de devis » :
 *   1) PATCHS au-delà de 100 pièces (prix « sur demande » ; 100 pile = 3,50 € HT).
 *   2) Panier ≥ 3 FAMILLES de produits différentes (commande multi-produits).
 */
(function () {
  function cart() {
    return (typeof window.getCartItems === 'function') ? (window.getCartItems() || []) : [];
  }

  /* Famille visible client d'un article. Regroupe coton+polyester = « tshirt ».
     Identifie patch/coin par le NOM (nommage interne inversé). */
  function cartFamily(item) {
    var n = (item.name || '').toLowerCase();
    var pt = item.productType || '';
    if (/patch/.test(n)) return 'patch';
    if (/coin/.test(n)) return 'coin';
    if (pt === 'sweatshirt' || /sweat/.test(n)) return 'sweatshirt';
    if (pt === 'tshirt' || pt === 'tshirt_polyester' || /t-?shirt/.test(n)) return 'tshirt';
    if (pt === 'drapeaux' || /drapeau/.test(n)) return 'drapeau';
    return pt || 'autre';
  }
  function countCartFamilies() {
    var fams = {};
    cart().forEach(function (i) { fams[cartFamily(i)] = true; });
    return Object.keys(fams).length;
  }
  window.countCartFamilies = countCartFamilies;

  /* Libellés client des familles. Le nom d'un article porte sa couleur et sa
     taille (« Textile - Sweatshirt · Kaki foncé ») : inutilisable comme
     intitulé de ligne de facture. */
  var LIBELLE_FAMILLE = {
    patch: 'Patchs personnalisés',
    coin: 'Coins métal personnalisés',
    sweatshirt: 'Sweatshirts personnalisés',
    tshirt: 'T-shirts personnalisés',
    drapeau: 'Drapeaux personnalisés'
  };

  /**
   * Le panier AGRÉGÉ PAR FAMILLE, pour le chiffrage.
   *
   * `details` (plus bas) aplatit chaque article en une phrase : la quantité et
   * la nature du produit n'y sont plus exploitables. L'admin recevait donc un
   * devis de 164 unités avec UN seul champ de prix — un patch à 2 € et un
   * sweatshirt à 40 € partageant le même prix unitaire.
   *
   * Cette liste part EN PLUS de `details`, qui reste tel quel : il sert
   * toujours à l'affichage, et les devis déjà en base n'ont que lui.
   *
   * @returns {Array<{cle:string, libelle:string, qty:number, lignes:string[]}>}
   */
  function cartFamilies() {
    var parCle = {};
    var ordre = [];

    regrouperArticles(cart()).forEach(function (i) {
      var cle = cartFamily(i);
      if (!parCle[cle]) {
        parCle[cle] = {
          cle: cle,
          libelle: LIBELLE_FAMILLE[cle] || (i.name || 'Articles'),
          qty: 0,
          lignes: []
        };
        ordre.push(cle);
      }
      parCle[cle].qty += (i.qty || 1);
      /* Le détail de chaque article reste attaché à sa famille : l'atelier le
         retrouve en propriété de la ligne correspondante, au lieu d'un bloc
         global détaché des prix. */
      parCle[cle].lignes.push(
        (i.qty || 1) + '× ' + (i.name || 'Article') +
        (i.color ? ' — ' + i.color : '') + (i.size ? ' — ' + i.size : '')
      );
    });

    return ordre.map(function (c) { return parCle[c]; });
  }
  window.cartFamilies = cartFamilies;

  /* ARTICLES IDENTIQUES REGROUPÉS pour le devis.

     Une répartition par tailles crée UNE ligne de panier PAR PIÈCE
     (conf-size-quantity-modal.js, « Toujours 1 par ligne ») : 33 t-shirts M
     partaient en 33 lignes « 1× … — M », avec 33 vignettes identiques, et
     l'admin recevait un devis de 68 lignes pour 4 articles réels.

     Même nom, même couleur, même taille ET même aperçu : une seule ligne, aux
     quantités additionnées. L'aperçu fait partie de la clé — une liste de
     surnoms a une planche par personne, ses lignes restent distinctes.

     Appliqué à `details`, `previews` ET `familles` : le chiffrage
     (articles-devis.ts) associe ces listes entre elles, elles doivent donc
     être découpées de la même façon. */
  function regrouperArticles(items) {
    var parCle = {};
    var out = [];
    (items || []).forEach(function (i) {
      if (!i) return;
      var cle = [i.name || '', i.color || '', i.size || '', apercuDeLigne(i).url || ''].join('|');
      if (parCle[cle]) {
        parCle[cle].qty += (i.qty || 1);
        return;
      }
      var copie = Object.assign({}, i, { qty: i.qty || 1 });
      parCle[cle] = copie;
      out.push(copie);
    });
    return out;
  }

  /* Quantité totale de PATCHS (ciblés par nom « Patch… »). */
  function patchQtyInCart() {
    return cart().reduce(function (s, i) {
      return s + (/patch/i.test(i.name || '') ? (i.qty || 0) : 0);
    }, 0);
  }

  /* Le panier contient-il au moins un COIN (« Coin métal ») ? Ciblé par nom
     (nommage interne inversé). */
  function hasCoinInCart() {
    return cart().some(function (i) { return /coin/i.test(i.name || ''); });
  }

  /* Cette LIGNE est-elle sans prix public ?

     Les coins sont chiffrés à la main : ils n'ont aucune grille tarifaire
     (conf-pricing-tiers.js) et leur prix est forcé à 0 quoi que réponde le
     backend (configurateur.liquid). Ce 0 est une absence de prix, pas une
     gratuité — l'afficher « 0,00 € » contredisait le message de devis figurant
     dans le même tiroir.

     À ne pas confondre avec `cartNeedsQuote()`, qui décrit le PANIER : un
     panier de plus de 100 patchs part aussi en devis, mais ses patchs ont un vrai prix
     (3,50 € HT) et doivent continuer de l'afficher. La question posée ici est
     différente : cet article a-t-il un prix à montrer ?

     Ciblé par NOM, comme les trois fonctions ci-dessus : `productType` vaut
     'coins' pour les coins dans certains fichiers et pour les patchs dans
     d'autres — le nom affiché, lui, est sans ambiguïté. */
  function ligneSurDevis(item) {
    return /coin/i.test((item && item.name) || '');
  }
  window.ligneSurDevis = ligneSurDevis;

  /* Ce coin a-t-il DEUX faces à produire ?

     Le type choisi par le client (« Recto verso », « Recto simple »,
     « Recto verso numéroté ») est concaténé dans `color` avec les autres
     détails, séparés par « · » (conf-main-inline.js, addCustomToCartInner) :
     « Type : Recto verso · Forme : Rond · Taille : 30 mm ».

     On cherche donc « recto verso » dans cette chaîne, ce qui couvre aussi
     « Recto verso numéroté ». « Recto simple » ne correspond pas — c'est
     voulu : une seule face est produite, en afficher deux laisserait croire à
     un verso à fabriquer. */
  function coinRectoVerso(item) {
    if (!ligneSurDevis(item)) return false;
    return /recto\s*-?\s*verso/i.test((item && item.color) || '');
  }

  /* L'image d'aperçu à envoyer au devis pour CET article.

     Par défaut la vignette du panier (`img`), qui ne montre que le RECTO
     (conf-main-inline.js : « img (vignette panier) = RECTO seul »). L'atelier
     ne voyait donc jamais le verso d'un coin recto verso — pas même son
     numéro, alors que le client l'avait demandé.

     Pour un coin à deux faces, on préfère la PLANCHE (`sheet`) : elle est déjà
     composée par le backend (/api/export/preview-multi) et porte les deux
     faces côte à côte, chacune sous son libellé RECTO / VERSO. Le numéro du
     verso y figure, capturé comme logo de cette face
     (captureCoinNumberImage).

     Repli systématique sur `img` : `sheet` vaut null quand la composition a
     échoué, ou quand une seule face portait un design — aucun devis ne doit
     perdre l'aperçu qu'il avait déjà. */
  function apercuDeLigne(item) {
    if (coinRectoVerso(item) && typeof item.sheet === 'string' &&
        /^https?:\/\//i.test(item.sheet)) {
      return { url: item.sheet, planche: true };
    }
    return { url: item && item.img, planche: false };
  }

  /* Le panier doit-il passer en devis plutôt qu'au paiement ? Devis si :
     - un COIN est présent (seul ou couplé à n'importe quel produit) ;
     - OU patchs AU-DELÀ de 100 pièces (à 100 pile, le palier 3,50 € HT s'applique) ;
     - OU ≥ 3 familles de produits différentes. */
  function cartNeedsQuote() {
    return hasCoinInCart() || patchQtyInCart() > 100 || countCartFamilies() >= 3;
  }
  window.cartNeedsQuote = cartNeedsQuote;

  /* Bascule le bouton bas de drawer entre checkout et demande de devis. */
  window.updateDrawerCheckoutBtn = function (isQuote) {
    var btn = document.getElementById('cd-checkout-btn');
    if (!btn) return;
    if (isQuote) {
      btn.setAttribute('onclick', 'requestCartQuote()');
      btn.innerHTML = 'Faire une demande de devis' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>';
    } else {
      btn.setAttribute('onclick', 'goToRecap()');
      btn.innerHTML = 'Continuer' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/></svg>';
    }
  };

  /* Routeur : ≥ 3 familles -> devis multi-produits ; sinon -> devis patchs. */
  window.requestCartQuote = function () {
    // Coin présent OU panier multi-familles -> devis global de tout le panier.
    // Sinon (patchs au-delà de 100 seuls) -> devis patchs.
    if (hasCoinInCart() || countCartFamilies() >= 3) return window.requestMultiProductQuote();
    return window.requestPatchQuoteFromCart();
  };

  /* Devis PATCHS seuls (au-delà de 100 pièces, prix « sur demande »). */
  window.requestPatchQuoteFromCart = function () {
    if (typeof window.closeCartDrawer === 'function') window.closeCartDrawer();
    var patchs = cart().filter(function (i) { return /patch/i.test(i.name || ''); });
    if (!patchs.length) { if (window.goToRecap) window.goToRecap(); return; }
    var totalQty = patchs.reduce(function (s, i) { return s + (i.qty || 0); }, 0);
    var details = patchs.map(function (i) {
      return (i.qty || 1) + '× ' + (i.name || 'Patch') +
             (i.size ? ' — ' + i.size : '') + (i.color ? ' — ' + i.color : '');
    });
    details.unshift('Total : ' + totalQty + ' patchs (prix sur demande au-delà de 100)');
    var previews = patchs.filter(function (i) {
      return typeof i.img === 'string' && /^https?:\/\//i.test(i.img);
    }).map(function (i, idx) { return { label: 'Patch ' + (idx + 1), base: i.img }; });
    window.openQuoteModal({
      name: 'Commande de patchs (' + totalQty + ' pièces)',
      subtitle: 'Recevez un devis pour votre commande de ' + totalQty + ' patchs.',
      details: details, qty: totalQty, previews: previews
    });
  };

  /* Devis MULTI-PRODUITS : panier mêlant ≥ 3 familles -> devis global. */
  window.requestMultiProductQuote = function () {
    if (typeof window.closeCartDrawer === 'function') window.closeCartDrawer();
    var items = regrouperArticles(cart());
    if (!items.length) { if (window.goToRecap) window.goToRecap(); return; }
    var totalQty = items.reduce(function (s, i) { return s + (i.qty || 0); }, 0);
    var details = items.map(function (i) {
      return (i.qty || 1) + '× ' + (i.name || 'Article') +
             (i.color ? ' — ' + i.color : '') + (i.size ? ' — ' + i.size : '');
    });
    var nFam = countCartFamilies();
    details.unshift('Commande sur devis : ' + nFam + ' famille(s), ' +
      items.length + ' ligne(s), ' + totalQty + ' pièce(s).');
    /* Un aperçu par article. Pour un coin recto verso, c'est la PLANCHE des
       deux faces qui part, et non la vignette du recto seul — voir
       `apercuDeLigne`. Le libellé le dit, sinon l'atelier ne saurait pas s'il
       regarde une face ou les deux. */
    var previews = items.map(function (i) {
      var ap = apercuDeLigne(i);
      if (typeof ap.url !== 'string' || !/^https?:\/\//i.test(ap.url)) return null;
      return {
        label: (i.name || 'Article') + (ap.planche ? ' — recto / verso' : ''),
        base: ap.url
      };
    }).filter(Boolean);
    // Sous-titre adapté : coin (toujours sur devis) vs simple mix multi-produits.
    var sub = hasCoinInCart()
      ? 'Les pièces (coins) sont chiffrées sur devis : recevez un devis global ' +
        'pour l’ensemble de votre commande.'
      : 'Votre panier mélange plusieurs types de produits : recevez un devis ' +
        'global pour l’ensemble de votre commande.';
    window.openQuoteModal({
      name: 'Commande sur devis (' + items.length + ' articles)',
      subtitle: sub,
      details: details, qty: totalQty, previews: previews,
      /* Le panier agrégé par famille : c'est lui qui permettra un prix par
         type de produit au chiffrage, et une facture détaillée pour le client.
         `details` reste envoyé tel quel, pour l'affichage et pour les devis
         déjà en base qui n'ont que lui. */
      familles: cartFamilies()
    });
  };
})();
